import { TFeaturedComponent } from "src/Featuresmap";
import { BaseForm, TFormType } from "./BaseForm";

type TCredentialsProps = {
	target_id: any;
	target_type: TFormType;
	onComplete?:()=>void
};

export const Credentials: TFeaturedComponent<TCredentialsProps> = ({ target_id, target_type, onComplete }) => {
	return <BaseForm target_id={target_id} target_type={target_type} type="credentials" onComplete={onComplete}/>;
};

Credentials.feature = "credentials";
